import { Observable } from 'rxjs';
import { CacheService } from './cache.service';
import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { DIMBO_CONSTANT } from './../utils/constant';
import { AppConfig } from '../app.config';
import { BehaviorSubject } from 'rxjs';

/** CommonService: shared token authentication utilities. */
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  domain: string;
  istokenreceived: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(
    private httpService: HttpService,
    private apiconfig :AppConfig,
    private cacheService: CacheService
    ) {

      let apipath=this.apiconfig.apiUrl;

      this.domain = apipath+this.apiconfig.apiPath;
     }

  // Method to call a API for token authentication
  public authenticateToken(token: string): Observable<any> {

    const finalUrl = this.domain + DIMBO_CONSTANT.AUTHENTICATE_TOKEN;
    return this.httpService.getCallForToken(finalUrl, token);
  }


}
